import { render, staticRenderFns } from "./BsiContinuousFilingFormDetailsBox.vue?vue&type=template&id=0b0d3a0c&scoped=true&"
import script from "./BsiContinuousFilingFormDetailsBox.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingFormDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingFormDetailsBox.vue?vue&type=style&index=0&id=0b0d3a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d3a0c",
  null
  
)

export default component.exports